import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import Util from "@/helper/Utility.js";
/**
 * @method requestOtp
 * @method confirmOtp
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} contactNumber (required)
     * @param {String} channel (optional)
     */
    requestOtp: function(contactNumber, channel) {
        var params = {
            contact_number: contactNumber,
            app_id: this.config().client_id,
            channel: channel,
        };

        var url = this.config().bzbsUrl + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params).pipe(map(res => res.data));
    },

    /**
     * @param {String} token
     * @param {String} contactNumber
     * @param {String} refcode
     * @param {String|Number} otp
     */
    confirmOtp: function(token, contactNumber, refcode, otp) {
        var params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
        };

        var url = this.config().bzbsUrl + "/auth/bzbs_authen";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
    validateOtp: function (contactNumber, refcode, otp, channel, type, use) {
        let params = {
            app_id: this.config().client_id,
            type: type,
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            channel: channel,
            use: use,
        };

        params = Util.cleanObjectEmptyStr(params);

        const url = this.config().bzbsUrl + "/auth/validate_otp";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map(res => res.data));
    },
}
